import { render, staticRenderFns } from "./TlmCountDown.vue?vue&type=template&id=13b1f9c0"
import script from "./TlmCountDown.vue?vue&type=script&lang=js"
export * from "./TlmCountDown.vue?vue&type=script&lang=js"
import style0 from "./TlmCountDown.vue?vue&type=style&index=0&id=13b1f9c0&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports